import { useNotification } from '@gohighlevel/ghl-ui';
export function useEvent() {
    const notification = useNotification();
    const sendNotification = (params) => {
        var _a;
        notification === null || notification === void 0 ? void 0 : notification.create(Object.assign(Object.assign({}, params), { duration: (_a = params.duration) !== null && _a !== void 0 ? _a : 5000 }));
    };
    const delay = (wait) => new Promise(resolve => setTimeout(resolve, wait));
    return {
        sendNotification,
        delay,
    };
}
